import React, { useEffect } from "react";
const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div className="bg-[#e9f6e8] font-lexend text-[#3a683f] ">
      <h1 className="xl:text-6xl lg:text-5xl text-4xl font-lexend pt-36 lg:pb-24 md:pb-16 pb-12 font-light text-center ">
        Privacy Policy
      </h1>
      <div className="w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[85rem] 2xl:px-0 xl:px-8 md:px-0 px-6  xs:px-4 mx-auto">
        <div className="pb-6 sm:text-sm text-base  flex flex-col gap-5 pe-5 font-light ">
          <p>
            Moondew, a brand operated by{" "}
            <span className="font-semibold">Livvon Comforts Pvt. Ltd.</span> ("we",
            "us", or "our"), is committed to protecting your privacy and
            personal data.
          </p>
          <p className="">
            This Privacy Policy explains how we collect, use, store, share, and
            protect your personal information when you visit
            https://moondew-demo.novatales.com/ ("Website") or use our products
            and services.
          </p>
          <p>
            By using our Website, you agree to the collection and use of
            information as described in this Privacy Policy.
          </p>
        </div>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Definitions
        </h2>
        <div className="pb-6 sm:text-sm text-base mt-1.5 flex flex-col gap-5  font-light ">
          <p>
            <span className="font-semibold">Personal Data</span> means any
            information that can identify an individual.
          </p>
          <p>
            {" "}
            <span className="font-semibold">Data Principal</span> means the
            individual whose personal data is being processed.
          </p>
          <p>
            {" "}
            <span className="font-semibold">Data Fiduciary</span> means the entity
            responsible for determining how and why personal data is processed.
            For this Website, the Data Fiduciary is MoonDew, a brand operated by
            Livvon Comforts Pvt. Ltd.
          </p>
        </div>
        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Information We Collect
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5">
          We may collect the following information:
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <p className="mt-1.5 font-semibold">Information You Provide</p>
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Full Name</li>
            <li>&nbsp;Email Address</li>
            <li>&nbsp;Phone Number</li>
            <li>&nbsp;Postal Address</li>
            <li>&nbsp;Billing and Shipping Information</li>
            <li>
              &nbsp;Information submitted through contact forms, support
              requests, or inquiries
            </li>
          </ul>
        </div>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <p className="mt-1.5 font-semibold">
            Information Collected Automatically
          </p>
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;IP Address</li>
            <li>&nbsp;Browser Type</li>
            <li>&nbsp;Device Information</li>
            <li>&nbsp;Website Usage Data</li>
            <li>&nbsp;Cookies and Tracking Information</li>
          </ul>
        </div>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <p className="mt-1.5 pb-6 font-semibold"> Transaction Information</p>
          <p>
            When you make a purchase, we may collect order and transaction
            details. Payment information is processed securely through
            authorized payment providers.
          </p>{" "}
        </div>
        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          How We Use Your Information
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          We use your information to:
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Process and fulfill orders</li>
            <li>&nbsp;Provide customer support</li>
            <li>&nbsp;Respond to inquiries</li>
            <li>&nbsp;Manage your account and purchases</li>
            <li>&nbsp;Improve our Website and services</li>
            <li>&nbsp;Analyze Website performance and usage</li>
            <li>&nbsp;Send order updates and service-related communications</li>
            <li>&nbsp;Send promotional communications where permitted</li>
            <li>&nbsp;Prevent fraud and maintain security</li>
            <li>&nbsp;Comply with legal obligations</li>
          </ul>
        </div>
        <p className="pb-6 sm:text-sm text-base font-light ">
          We use your personal data only for legitimate business purposes and as
          permitted by applicable law.
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Consent
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          Where required, we obtain your consent before collecting or processing
          personal data.
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <p>You may provide consent through:</p>
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Account registration</li>
            <li>&nbsp;Contact forms</li>
            <li>&nbsp;Newsletter subscriptions</li>
            <li>&nbsp;Checkout processes</li>
            <li>&nbsp;Cookie consent banners</li>
          </ul>
        </div>
        <p className="pb-6 sm:text-sm text-base font-light ">
          You may withdraw your consent at any time by contacting us using the
          details provided below.
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          {" "}
          Sharing of Information
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          We do not sell your personal data.
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <p>
            We may share your information with trusted third-party service
            providers, including:
          </p>
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Payment processors</li>
            <li>&nbsp;Shipping and logistics partners</li>
            <li>&nbsp;Cloud hosting providers</li>
            <li>&nbsp;Analytics providers</li>
            <li>&nbsp;Customer support platforms</li>
            <li>&nbsp;Marketing and communication service providers</li>
          </ul>
        </div>
        <p className="pb-6 sm:text-sm text-base font-light ">
          Some service providers may process data outside India. We take
          reasonable measures to ensure appropriate safeguards are in place to
          protect your information.
        </p>
        <p className="pb-6 sm:text-sm text-base font-light ">
          We may also disclose information when required by law or regulatory
          authorities.
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          {" "}
          Data Retention
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          We retain personal data only for as long as necessary to:
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Provide products and services</li>
            <li>&nbsp;Fulfill contractual obligations</li>
            <li>&nbsp;Comply with legal requirements</li>
            <li>&nbsp;Resolve disputes</li>
            <li>&nbsp;Enforce our policies</li>
          </ul>
        </div>
        <p className="pb-6 sm:text-sm text-base font-light ">
          When personal data is no longer required, we securely delete,
          anonymize, or archive it as appropriate.
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Your Rights
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          Subject to applicable law, you may have the right to:
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Access your personal data</li>
            <li>&nbsp;Request correction of inaccurate information</li>
            <li>&nbsp;Request deletion of personal data where applicable</li>
            <li>&nbsp;Withdraw consent</li>
            <li>
              &nbsp;Raise concerns regarding the processing of your personal
              data
            </li>
            <li>
              &nbsp;Nominate another individual to exercise your rights in the
              event of death or incapacity
            </li>
          </ul>
        </div>
        <p className="pb-6 sm:text-sm text-base font-light ">
          To exercise these rights, please contact us using the details below.
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Cookies and Tracking Technologies
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          We use cookies and similar technologies to improve your experience on
          our Website.
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <p>These technologies help us:</p>
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Enable essential Website functionality</li>
            <li>&nbsp;Remember user preferences</li>
            <li>&nbsp;Analyze Website traffic and performance</li>
            <li>&nbsp;Improve our products and services</li>
            <li>&nbsp;Measure marketing effectiveness</li>
          </ul>
        </div>
        <p className="pb-6 sm:text-sm text-base font-light ">
          You can manage or disable cookies through your browser settings. Some
          Website features may not function properly if cookies are disabled.
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Children's Privacy
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          Our Website and services are not intended for individuals under 18
          years of age.
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <p>
            We do not knowingly collect personal data from children. If we
            become aware that such information has been collected, we will take
            appropriate steps to delete it.
          </p>
        </div>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Data Security
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          We implement reasonable technical and organizational safeguards to
          protect your personal data, including:
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Secure data transmission</li>
            <li>&nbsp;Access controls</li>
            <li>&nbsp;Security monitoring</li>
            <li>&nbsp;Regular system updates</li>
            <li>&nbsp;Employee awareness and training</li>
          </ul>
        </div>
        <p className="pb-6 sm:text-sm text-base font-light ">
          While we strive to protect your information, no method of electronic
          transmission or storage is completely secure
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Changes to This Privacy Policy
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          We may update this Privacy Policy from time to time.
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <p>
            Any updates will be posted on this page along with the revised "Last
            Updated" date. Continued use of the Website after such changes
            constitutes acceptance of the updated Privacy Policy.
          </p>
        </div>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Contact & Grievance Redressal
        </h2>
        <p className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          If you have any questions, concerns, requests, or complaints regarding
          this Privacy Policy or our handling of personal data, please contact:
        </p>

        <p className="pb-6 sm:text-sm text-base font-light ">
          <span className="font-semibold">Moondew</span> <br /> SY NO.148 TSIIC,
          Kallakal, Telangana 502336
        </p>

        <p className="pb-6 sm:text-sm text-base font-light ">
          <span className="font-semibold">Email</span> : <a href="mailto:customercare@moondew.in" className="hover:underline">customercare@moondew.in</a>
        </p>

        <p className="pb-6 sm:text-sm text-base font-light ">
          We will make reasonable efforts to respond to your request within the
          timelines required under applicable law.
        </p>

        <div className="w-full h-56 pb-5 flex justify-center items-center  ">
          <span className="bg-[#cfeccd] md:px-10 px-5 py-3 md:text-base text-sm font-light font-lexend text-center">
            By using our Website, you acknowledge that you have read and
            understood this Privacy Policy and agree to its terms.
          </span>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
